import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./menu_item_sale_unit.js";
//#region src/menu_item_sale_unit_helper.ts
var menu_item_sale_unit_helper_exports = /* @__PURE__ */ __exportAll({
	name: () => name,
	notation: () => notation
});
function name(saleUnit) {
	switch (saleUnit) {
		case 0: return "Each";
		case 2: return "Pounds";
		case 3: return "Ounces";
	}
}
function notation(saleUnit) {
	if (typeof saleUnit === "undefined") return "";
	switch (saleUnit) {
		case 0: return "";
		case 2: return "lb";
		case 3: return "oz";
	}
}
//#endregion
export { menu_item_sale_unit_helper_exports, name, notation };

//# sourceMappingURL=menu_item_sale_unit_helper.js.map